import { useEffect, useState } from "react";
import { Button, InputGroup } from "react-bootstrap";

import ToolTip from "components/ToolTip/ToolTip";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { PerfilManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import { GridView } from "components/GridView/GridView";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import IconButton from "components/IconButton/IconButton";
import {
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal,
} from "..";
import { AutoComplete } from "components";
import "../Lookup.style.scss";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { useRef } from "react";
import { Simplebar } from "components/Simplebar/Simplebar";
import { SvgComponent } from "components/SvgComponent/SvgComponent";
import { DEFAULT_PAGINATION_VALUES } from "utils";

export const PerfilLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  isDisabled,
  where,
  size = "lg",
}) => {
  const ref = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [list, setList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({ label: "", value: "" });
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [whereModal, setWhereModal] = useState(initialWhereModal);
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  useEffect(() => {
    if (whereModal != initialWhereModal) {
      buscar();
    }
  }, [whereModal, where]);

  useEffect(() => {
    if (
      selectedValue != undefined &&
      selectedValue.value !== null &&
      selectedValue.value != ""
    ) {
      onChange(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (
      initialValue.value &&
      initialValue.value != "" &&
      initialValue.value !== selectedValue.value
    ) {
      setValue();
    }
  }, [initialValue.value]);

  const setValue = () => {
    PerfilManager.buscarPorId(initialValue.value, true).then((data) =>
      setSelectedValue(data)
    );
  };

  function buscar() {
    const whereWithPaginationValues = { ...whereModal, ...pagination };
    PerfilManager.listado(
      where
        ? { ...whereWithPaginationValues, ...where }
        : whereWithPaginationValues
    )
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setList(res.Data);
      })
      .catch((err) => handleException(err));
  }

  const handleCerrar = () => {
    setShowCanvas(false);
    setWhereModal(initialWhereModal);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const res = await PerfilManager.listado({
      ...initialWhere,
      Nombre: inputValue,
    });
    return res.Data;
  };

  return (
    <>
      <InputGroup className="w-100">
        <div style={{ width: controlsProportion.input }}>
          <AutoComplete
            placeholder="Perfiles"
            getList={getSuggestions}
            parentValue={selectedValue}
            setParentValue={setSelectedValue}
            isDisabled={isDisabled}
          />
        </div>
        <InputGroup.Append style={{ width: controlsProportion.button }}>
          <AnimatedIconButton
            size="40px"
            height="18"
            width="18"
            message="Seleccionar Perfil"
            style={buttonStyle}
            disabled={isDisabled}
            iconName="search"
            onClick={() => {
              setShowCanvas(true);
              setTimeout(() => {
                buscar();
              }, 200);
            }}
          />
        </InputGroup.Append>
      </InputGroup>
      {showCanvas && (
        <Simplebar
          backdrop={true}
          ref={ref}
          placement={"end"}
          portal={false}
          size={size}
          useLoading={true}
          visible={showCanvas}
          setShow={(e) => {
            setShowCanvas(e);
          }}
          title="Seleccionar Perfil"
          btnLeft={{
            show: false,
            func: () => {},
          }}
          btnRight={{
            show: false,
            func: () => {},
          }}
        >
          <GridView
            pagination={pagination}
            setPagination={setPagination}
            allowPaging={pagination.EsPaginable}
            pageSize={pagination.CantidadPorPagina}
            pageIndex={pagination.IndiceDePagina}
            lastPageNumber={pagination.PaginasTotal}
            dataSource={list}
            onPageIndexChanging={onPageIndexChanging}
            where={whereModal}
            setWhere={setWhereModal}
          >
            <GridView.Column
              bodyRenderer={(row) => {
                return (
                  <div className="float-right">
                    <IconButton
                      onClick={() => {
                        setSelectedValue({
                          label: row.Nombre,
                          value: row.IdSec,
                        });
                        handleCerrar();
                      }}
                    >
                      <ToolTip message="Seleccionar">
                        <div>
                          <SvgComponent
                            height="20"
                            width="20"
                            iconName="check"
                          />
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div>
                );
              }}
            />
            <GridView.Column
              headerText="Id"
              dataField="IdSec"
              sortExpression="IdSec"
            />
            <GridView.Column
              headerText="Nombre"
              dataField="Nombre"
              sortExpression="Nombre"
            />
          </GridView>
        </Simplebar>
      )}
    </>
  );
};
